import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './services/auth';
import { useAuth } from './hooks';
import { SignInScreen, LoadingScreen } from './components';
import { MainPage } from './app/MainPage';

function AuthenticatedApp() {
  const { isAuthenticated, isLoading, admin, signIn, signOut, error } = useAuth();

  if (isLoading) {
    return <LoadingScreen message="Authenticating..." />;
  }

  if (!isAuthenticated || !admin) {
    return <SignInScreen onSignIn={signIn} error={error} />;
  }

  return <MainPage admin={admin} onSignOut={signOut} />;
}

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <FluentProvider theme={webLightTheme}>
        <AuthenticatedApp />
      </FluentProvider>
    </MsalProvider>
  );
}
